import React, { useState, useEffect, useRef } from "react";
import { States } from "../../../helpers/state";

import { useReactToPrint } from 'react-to-print';
import { Grid, Button, Typography, List, ListItem } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useLocation } from "react-router";
import { environment } from "../../../environments/environment";
import Snackbar from "../../../Components/Snackbar";
import Services from "../../../Services";
// import down from "../../assets/Icons/DownloadIcon.svg"
import {
  PhoneNumber,
  SsnModal,
  StatusModal,
  EmployeeIdModal,
  RehireModal,
  AddressModal,
  EditEmergencyContact,
} from "../../../Imports/ModalImports";
import {
  AddressTable,
  CertificateTable,
  PositionTable,
  PayDetails,
  ListItemResult,
} from "../../../Imports/TableImports";
import AttachmentFiles from "../../../Components/AttachmentFiles/AttachmentFiles";
import {
  ValidateDate,
  ValidateText,
  ValidateTextNull,
  showText,
  showTextEmpty,
} from "../../../helpers/textValidation";
import jsPDF from "jspdf";
import { getQuestion, getDataSheet } from "../../../helpers/textValidation";
import { message, Modal, Popover, Tabs } from "antd";
import { DownloadForOffline, PrintOutlined } from "@mui/icons-material";
import HardwareTable from "../../../Components/TableComponents/HardwareTable";
import HireDateModal from "../../../Components/Modals/HireDateModal";
import TerminatedEditModal from "../../../Components/Modals/TerminatedEditModal";
import { formatPhoneNumber } from "../../../helpers/formatedNumber";
import QuestionaireDataSheet from "../NewHireQueue/Questionaire&DataSheet";
import DateOfBirth from "../../../Components/Modals/DateOfBirthModal";
import roleManager from "../../../Components/roles";
import GoBack from "../../../Components/GoBackButton/GoBack";
import { gellAllLocomotiveLocations } from "../../../Services/LocomotiveServices";
import { seriliazeParams } from "../../../helpers/seriliazeParams";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
import EmployeePasswordChangeModal from "../../../Components/Modals/EmployeePasswordChange";
import TabsComponent from "../../../Components/Tabs";
import { CloudDownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import { deleteEmployeeDocument } from "../../../Services/hr";
import { routes } from "../../../Services/api/routes";
import { utility } from "../../../helpers/loader";
import { setPageLoader } from "../../../redux/features/utils.slice";
import EmployeeDocumentDeleteModal from "../../../Components/Modals/EmployeeDocumentDeleteModal";
import { haveAccessByRole } from "../../../helpers";

var moment = require("moment-timezone");

const { apiPath } = environment;

const { hr, employee } = Services;

const permission = {
  showPosition: [2, 5],
  showPay: [2, 5],
  showTerminate: [2, 5],
  hrAdminOrSystemAdmin: [2, 5],
  attachfile: [2, 5],
};

const EmployeeResult = (props) => {

  let history = useHistory();

  const location = useLocation();

  const [selectedTab, setSelectedTab] = useState("1")
  const [employeeDetails, setEmployeeDetails] = useState({});

  const [files, setFiles] = useState([]);

  const [additionalFiles, setAdditionalFiles] = useState([]);

  const [position, setPosition] = useState([]);
  const [DataSheetDataEmergency, setDataSheetDataEmergency] = useState(null)


  const [tgsLocation, setTgsLocation] = useState({});

  const [department, setDepartment] = useState({});

  const [loader, setLoader] = useState(false);

  const [stateName, setStateName] = useState(null);

  const [payRate, setPayRate] = useState([]);
  const [isDeleteDocModalOpen, setIsDeleteDocModalOpen] = useState({ name: null, flag: false })
  const [flag, setFlag] = useState(false);

  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [employeeInitialData, setEmployeeInitialData] = useState();

  const [emergencyContact, setEmergencyContact] = useState();

  const [OpenQuesModal, setOpenQuesModal] = useState(false)
  const [QuestionnaireData, setQuestionnaireData] = useState(null)
  const [DataSheetData, setDataSheetData] = useState(null)
  const [isDataSheetModalOpen, setisDataSheetModalOpen] = useState(false)
  const [stateCheck, setstateCheck] = useState(false)
  const [TabsRender, setTabsRender] = useState([])
  const tabState = useState(location?.state?.activeTab || 0);
  const [DateOfBirthModalStatus, setDateOfBirthModalStatus] = useState(false)
  const DateOfBirthModal = () => {
    setDateOfBirthModalStatus(!DateOfBirthModalStatus)
  };
  // STATUS MODAL STATES

  const [statusModal, setStatusModal] = useState(false);
  const [updateStatus, setUpdateStatus] = useState();
  const [statusDate, setStatusDate] = useState();
  useEffect(() => {
    if (!additionalFiles.length) {
      if (!additionalFiles.length) return false;
      clearAdditionalFiles();
    }
  }, [additionalFiles]);

  const clearAdditionalFiles = () => {
    additionalFiles.value = null;
    setAdditionalFiles([]);
  };

  function terminateEmployee() {
    history.push({
      pathname: "/employees-profile/termination",
      state: location?.state,
    });
  }

  const [lists, setLists] = useState({
    users: [],
    positions: [],
    departments: [],
    sites: [],
    level: [],
  });

  const handleCloseQuesModal = () => {
    setOpenQuesModal(false)
  }

  const onCancelDataSheetModal = () => {
    setisDataSheetModalOpen(false)
  }
  const [statusList, setStatusList] = useState([]);

  useEffect(async () => {
    let res = await hr.onUpdateStatusList();
    let newList = res?.data.map((status) => ({
      status: status?.name,
      key: status?.id,
    }));
    setStatusList(newList);

    let departmentList = await employee.get_subDepartment_listing();
    if (departmentList.httpStatus == 200) {
      departmentList = departmentList.data || [];
    }

    let jobCategoryList = await employee.get_job_category_listing();
    if (jobCategoryList.httpStatus == 200) {
      jobCategoryList = jobCategoryList.data || [];
    }

    let params = '?'.concat(seriliazeParams({
      locationType: 'ALL,OFF'
    }))
    let siteList = await gellAllLocomotiveLocations({ params });
    if (siteList.httpStatus == 200) {
      siteList = siteList.data || [];
    }

    let userList = await employee.get_employee_listing_not_Terminated();
    if (userList.httpStatus == 200) {
      userList = userList.data;
      userList.map((row) => {
        row.name = `${row.firstName} ${row.lastName}`;
      });
    }

    let level = await hr.getPositionLevel();
    if (level.httpStatus == 200) {
      level = level.data;
    }

    setLists({
      ...lists,
      users: userList,
      positions: jobCategoryList,
      departments: departmentList,
      sites: siteList,
      level,
    });
  }, []);

  useEffect(async () => {
    window.scrollTo(0, 0);

    let id = location?.state?.employee?.[0]?.id;

    try {
      getEmployeeDetails({ id });
    } catch (exc) {

    }
  }, [flag]);

  // For Modal
  const [openAdd, setOpenA] = useState(false);

  function handleClickOpenAdd(row) {
    setOpenA(true);
  }

  async function onSubmitEmploye(event) {
    try {
      event.preventDefault();

      const formData = new FormData();
      const { id } = employeeDetails;

      Array.from(additionalFiles).forEach((file) => {
        formData.append("file", file);
      });

      const response = await hr.additionalFilesEMP({
        id,
        formData,
      });

      await getEmployeeDetails();
      clearAdditionalFiles();
    } catch (exc) {

    }
  }



  const getEmployeeDetails = async (forcedParams = {}) => {
    try {
      const applicantDataHistory = await hr.getEmployee({
        ...(employeeDetails || {}),
        ...forcedParams,
      });

      setLoader(true);
      setEmployeeDetails({
        ...applicantDataHistory?.employee[0],
        positionName: applicantDataHistory?.position[0]?.EmployeeLevel?.name,
      });
      setDataSheetData(applicantDataHistory.employee[0])
      setQuestionnaireData(applicantDataHistory?.data)
      setDataSheetDataEmergency(applicantDataHistory?.emergency_contact[0])

      let {
        id,
        jobId,
        firstName,
        lastName,
        middleName,
        cellPhone,
        homePhone,
        TGSLocation,
        SEmployee,
        dateOfBirth,
        ssn,
        hireDate,
        terminateDate,
        terminateReason,
      } = applicantDataHistory?.employee[0];
      let {
        name,
        relationship,
        phoneNumber,
        BckName,
        BckPhone,
        BckRelationship,
      } =
        applicantDataHistory?.emergency_contact?.length &&
        applicantDataHistory?.emergency_contact[0];

      //  
      setEmployeeInfo({
        job_ID: jobId || "N/A",
        employee_id: `${showText(
          applicantDataHistory?.employee[0]?.id
        )} / ${showText(applicantDataHistory?.employee[0]?.uid)}`,
        full_name: `${firstName} ${middleName ? middleName : " "} ${lastName}`,
        full_title: applicantDataHistory?.position[0]?.FullTitle || "N/A",
        phoneNumber: `${showText(formatPhoneNumber(homePhone))} ${cellPhone ? `/ ${showText(formatPhoneNumber(cellPhone))}` : ""
          }`,
        location: TGSLocation?.name,
        supervisor: `${SEmployee?.firstName} ${SEmployee?.lastName}`,
        ssn: `***${ssn?.slice(-6)}`,
        emergencyContact:
          emergencyContactformat(name, relationship, formatPhoneNumber(phoneNumber)) +
          "" +
          emergencyContactformat(BckName, BckRelationship, formatPhoneNumber(BckPhone), true),
        hiredate: ValidateText(hireDate, ValidateDate(hireDate)),
        terminationdate: ValidateTextNull(
          terminateDate,
          `${ValidateDate(terminateDate)} - ${showText(terminateReason)}`
        ),
        dateOfBirth: ValidateDate(dateOfBirth)
      });

      if (applicantDataHistory?.emergency_contact?.length)
        setEmergencyContact(applicantDataHistory?.emergency_contact[0]);

      setFiles(applicantDataHistory?.files);
      setPosition(
        applicantDataHistory?.position
          .sort((a, b) => new Date(a.EffectiveDate) - new Date(b.EffectiveDate))
          .reverse()
      );
      setPayRate(applicantDataHistory?.pay);
      if (applicantDataHistory?.position?.length)
        setEmployeeInitialData(applicantDataHistory?.position[0]);
      if (!applicantDataHistory?.position?.length)
        setEmployeeInitialData({
          ...applicantDataHistory?.employee[0],
          JobCategoryId: 1,
        });
      setTgsLocation(applicantDataHistory?.employee[0].TGSLocation);
      setDepartment(applicantDataHistory?.employee[0]?.SubDepartment);
      setStateName(applicantDataHistory?.employee[0]?.state);
      setUpdateStatus(
        statusList[applicantDataHistory?.employee[0]?.EmployeeStatusId - 1]
      );
      setLoader(false);
    } catch (err) {

    }
  };
  const emergencyContactformat = (name, relationship, phoneNumber, bck) => {
    if (name || relationship || phoneNumber)
      return `${bck ? `/` : ""} ${showText(name)} (${showText(
        relationship
      )}) - ${showText(phoneNumber)}`;
    return bck ? "" : "N/A";
  };


  const removeFile = (fileIndexToOptOut) => {
    const files = Array.from(additionalFiles).filter(
      (_, fileIndex) => fileIndex !== fileIndexToOptOut
    );

    setAdditionalFiles(files);
  };

  // REHIRE MODAL STATES

  const [rehireModal, setRehireModal] = useState(false);

  const onClickRehireModal = () => {
    setRehireModal(true);
  };

  // EMPLOYEE_ID MODAL STATES
  const [EmployeeidModal, setEmployeeidModal] = useState(false);

  const onClickEmployeeIdModal = () => {
    setEmployeeidModal(true);
  };


  const onClickStatusModal = () => {
    setStatusModal(true);
  };

  // SSN MODAL STATE

  const [ssnNumberModal, setSsnNumberModal] = useState(false);
  const onClickEditSsnNumber = () => {
    setSsnNumberModal(true);
  };

  // PHONE NUMBER MODAL

  const [editNumberModal, setEditNumberModal] = useState(false);
  const onClickEditPhoneNumber = () => {
    setEditNumberModal(true);
  };

  // EMERGENCY CONTACT MODAL
  const [openContact, setOpenContact] = useState(false);
  const onClickEditEmergencyContact = () => {
    setOpenContact(true);
  };

  const [openEditHireDate, setOpenEditHireDate] = useState(false);
  const onClickEditHireDate = () => {
    setOpenEditHireDate(true);
  };
  const [openEditTerminateDetails, setOpenEditTerminateDetails] = useState(false);
  const onClickEditTerminateDetails = () => {
    setOpenEditTerminateDetails(true);
  };

  const findNameAgainstStatusKey = (value) => {
    const result = statusList.find((o) => o.key == value);
    return result?.status;
  };

  // MODAL DATA OBJECTS

  let phoneNumberModal = {
    employeeDetails: employeeDetails,
    open: editNumberModal,
    close: setEditNumberModal,
    setMainFlag: setFlag,
    mainFlag: flag,
  };
  let EmployeeIdModalData = {
    open: EmployeeidModal,
    close: setEmployeeidModal,
    employeeDetails: employeeDetails,
    setMainFlag: setFlag,
    mainFlag: flag,
  };

  let DateOfBirthData = {
    open: DateOfBirthModalStatus,
    close: DateOfBirthModal,
    employeeDetails: employeeDetails,
    setMainFlag: setFlag,
    mainFlag: flag,
  };

  let SsnModalNumber = {
    open: ssnNumberModal,
    close: setSsnNumberModal,
    employeeDetails: employeeDetails,
    setMainFlag: setFlag,
    mainFlag: flag,
  };

  const questionModalContent = getQuestion(QuestionnaireData)

  let statusData = {
    employeeDetails: employeeDetails,
    open: statusModal,
    close: setStatusModal,
    changeDate: setStatusDate,
    updateStatus: setUpdateStatus,
    updateStatusState: updateStatus,
    dateStatus: statusDate,
    listStatus: statusList,
    mainFlag: flag,
    setMainFlag: setFlag,
  };

  let RehireModalData = {
    open: rehireModal,
    close: setRehireModal,
    mainFlag: flag,
    setMainFlag: setFlag,
    employeeDetails: employeeDetails,
  };

  let addressModalData = {
    employeeDetails: employeeDetails,
    open: openAdd,
    close: setOpenA,
    stateName: stateName,
    setStateName: setStateName,
    emergencyContact: emergencyContact,
    getEmployeeDetails: getEmployeeDetails,
  };

  let emergencyModalData = {
    employeeDetails: employeeDetails,
    emergencyContact: emergencyContact,
    open: openContact,
    close: setOpenContact,
    statesList: States,
    mainFlag: flag,
    setMainFlag: setFlag,
  };

  let HireModalData = {
    employeeDetails: employeeDetails,
    open: openEditHireDate,
    close: setOpenEditHireDate,
    mainFlag: flag,
    setMainFlag: setFlag,
  }
  let TerminateDate = {
    employeeDetails: employeeDetails,
    open: openEditTerminateDetails,
    close: setOpenEditTerminateDetails,
    mainFlag: flag,
    setMainFlag: setFlag,
  }
  // =========================================

  let Tables = {
    address: {
      data: employeeDetails,
      onClick: handleClickOpenAdd,
    },
    certificate: {
      employeeId: location?.state?.employee?.[0]?.id,
      employeeDetails,
      flag,
      setFlag,
    },
    position: {
      data: position,
      lists: lists,
      flag,
      setFlag,
      employeeInitialData,
      employeeDetails,
    },
    payDetails: {
      data: payRate,
      employeeDetails,
      flag,
      setFlag,
    },
  };
  const handleDownload = (name) => {
    const downloadUrl = `${apiPath}/employee/applicant/download?id=${employeeDetails?.ApplicantId ? employeeDetails?.ApplicantId : employeeDetails?.id
      }&name=${name}`;
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const attatchmentFilesdata = {
    additionalFiles: additionalFiles,
    setAdditionalFiles: setAdditionalFiles,
    removeFile: removeFile,
    onSubmitEmploye: onSubmitEmploye,
  };


  const tabsItems = [
    {
      key: "1",
      label: <span style={{ fontSize: '15px' }}>ADDRESS</span>,
      children: <AddressTable emp={employeeDetails} onClick={handleClickOpenAdd} />
    },
    {
      key: "2",
      label: <span style={{ fontSize: '15px' }}> CERTIFICATIONS & LISCENSES</span>,
      children: <CertificateTable tableData={Tables.certificate} />
    },
    ...(roleManager("employeeLookup", "sections", "position") ? [{
      key: "3",
      label: <span style={{ fontSize: '15px' }}> POSITION</span>,

      children: <PositionTable tableData={Tables.position} />
    }] : []),
    ...(roleManager("employeeLookup", "sections", "position") ? [{
      key: "4",
      label: <span style={{ fontSize: '15px' }}> PAY DETAIL </span>,

      children: <PayDetails tableData={Tables?.payDetails} />
    }] : []),

    {
      key: "5",
      label: <span style={{ fontSize: "15px" }}>EMPLOYEE DOCUMENT</span>,
      children: (
        <>
          {((payRate?.length > 0 && haveAccessByRole(13)) || roleManager("employeeLookup", "sections", "showDocuments")) && (
            <div style={{ display: "flex", flexDirection: "column", }} className="">
              <Typography className="bold mb10">Employee Documents</Typography>
              <div className="HREmployeeDownloads">
                {files?.length ? (
                  files?.map((name) => (
                    <Grid
                      container
                      key={name}
                      alignItems="center"
                      justifyContent="space-between"
                      className={`${name.endsWith(".pdf") ? "PDFDownload" : "PngDownload"
                        }`}
                      style={{ marginTop: "2px" }}
                    >
                      <Grid item className="FileName" style={{ flex: 1, color: "black" }}>
                        <a
                          href={`${apiPath}/employee/applicant/download?id=${employeeDetails?.ApplicantId
                            ? employeeDetails?.ApplicantId
                            : employeeDetails?.id
                            }&name=${name}`}
                          download
                          style={{ fontSize: "16px", color: 'black' }}
                        >
                          {name}
                        </a>
                      </Grid>
                      <Grid item>
                        {roleManager("sidebar", "systemAdmin") && (
                          <DeleteOutlined
                            style={{ color: "red", cursor: "pointer", fontSize: "18px", marginRight: "10px" }}
                            onClick={() => setIsDeleteDocModalOpen({ name: name, flag: true })}
                          />
                        )}

                      </Grid>
                      <Grid item>
                        <CloudDownloadOutlined style={{ marginRight: "10px", color: "gray" }}
                          onClick={() => handleDownload(name)} // Call your download function here
                        />
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <Grid style={{ width: "100%", fontSize: "12px" }}>No files found!</Grid>
                )}
              </div>
            </div>
          )}
          <AttachmentFiles data={attatchmentFilesdata} />
        </>
      ),
    }


  ]

  const employeeinfo = [

    roleManager("employeeLookup", "sections", "EmployeeId", "dateOfBirth") && {
      head: "Employee ID",
      text: employeeInfo?.employee_id,
      span: false,
      visibility: true,
      showButton: roleManager("employeeLookup", "sections", "EmployeeIdEdit"),
      onClick: onClickEmployeeIdModal,
    },
    {
      head: "Full Name",
      text: employeeInfo?.full_name,
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Full Title",
      text: employeeInfo?.full_title,
      span: false,
      visibility: true,
      showButton: false,
    },
    roleManager("employeeLookup", "sections", "dateOfBirth") &&
    {
      head: "Date Of Birth",
      text: employeeInfo?.dateOfBirth,
      span: false,
      visibility: true,
      showButton: roleManager("employeeLookup", "employeeInfo", "dateOfBirth"),
      onClick: DateOfBirthModal,
    },

    {
      head: "Phone Number",
      text: employeeInfo?.phoneNumber,
      span: "(Home / Cell)",
      visibility: true,
      showButton: roleManager("employeeLookup", "employeeInfo", "phoneNumber"),
      onClick: onClickEditPhoneNumber,
    },
    {
      head: "Full title",
      text: "Director of Systems",
      span: false,
      visibility: employeeDetails?.fullTitle,
      showButton: false,
    },
    {
      head: "Location",
      text: employeeInfo?.location,
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Supervisor",
      text: employeeInfo?.supervisor,
      span: false,
      visibility: true,
      showButton: false,
    },
    roleManager("employeeLookup", "sections", "Status") && {
      head: "Status",
      text: findNameAgainstStatusKey(employeeDetails?.EmployeeStatusId),
      onClick: onClickStatusModal,
      span: false,
      showButton: true,
      visibility: true,
    },
    {
      head: "Sub Department",
      text: `${department?.name} - ${employeeInfo?.job_ID}`,
      span: false,
      showButton: false,
      visibility: true,
    },
    // {
    //   head: "Job ID",
    //   text: employeeInfo?.job_ID,
    //   span: false,
    //   showButton: false,
    //   visibility: true,
    // },
    {
      head: "SSN",
      text: employeeInfo?.ssn,
      onClick: onClickEditSsnNumber,
      visibility: roleManager("employeeLookup", "employeeInfo", "ssn"),
      showButton: roleManager("employeeLookup", "employeeInfo", "ssnEdit"),
      span: false,
    },
    {
      head: "Emergency Contact",
      text: employeeInfo?.emergencyContact,
      span: "(Primary / Backup)",
      onClick: onClickEditEmergencyContact,
      showButton: roleManager("employeeLookup", "employeeInfo", "emergencyContact"),
      visibility: true,
    },
    roleManager("employeeLookup", "sections", "HireDate") && {
      head: "Hire Date",
      text: employeeInfo?.hiredate,
      visibility: true,
      onClick: onClickEditHireDate,
      showButton: roleManager("employeeLookup", "employeeInfo", "hireDate"),
      span: false,
    },
    {
      head: "Termination Date",
      text: employeeInfo?.terminationdate,
      visibility: employeeInfo?.terminationdate,
      showButton: roleManager("employeeLookup", "employeeInfo", "terminationDate"),
      span: false,
      onClick: onClickEditTerminateDetails
    },
  ];



  let QDProps = {
    handleCloseQuesModal,
    onCancelDataSheetModal,
    QuestionnaireData,
    DataSheetData,
    DataSheetDataEmergency,
    OpenQuesModal,
    setOpenQuesModal,
    isDataSheetModalOpen,
    setisDataSheetModalOpen
  }

  useEffect(() => {

  }, [stateCheck])

  return loader ? (
    <div>Loading...</div>
  ) : (
    <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
      <QuestionaireDataSheet {...QDProps} />
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Employee Lookup</Grid>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <GoBack path="/employees" />
        </div>
        <Grid xs={12} className="ContentPage BlueHeadTable FormTableArea">
          <Grid xs={12} style={{ display: "flex", }}>
            <Grid xs={7}>
              <List>
                <ListItemResult data={employeeinfo} />
              </List>
            </Grid>
            <Grid xs={5} className="DashTable-Desk">
              <Typography variant="h1" component="h2" className="bold f22" style={{ marginBottom: "0px", marginTop: "50px" }}>
                Assigned Hardware
              </Typography>
              <HardwareTable disabled={true} employee={employeeDetails} page={"result"} />
            </Grid>
          </Grid>
          <Grid xs={2} style={{ marginTop: "20px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
              {roleManager("employeeLookup", "sections", "questionare") &&
                <Button
                  className="QD-Btn-link"
                  onClick={() => setOpenQuesModal(true)}
                  disabled={questionModalContent ? false : true}
                >
                  Questionnaire

                </Button>
              }
              <Button
                className="QD-Btn-link"
                onClick={() => setisDataSheetModalOpen(true)}
              >
                Data Sheet
              </Button>
            </div>
          </Grid>
          <Grid>
            {roleManager("employeeLookup", "sections", "position") && (
              <>

                {!employeeDetails?.terminate ? (
                  <Grid xs={12} container className="mt40">
                    {roleManager("employeeLookup", "sections", "terminationDate") &&

                      <Button
                        onClick={terminateEmployee}
                        className="LinkButton"
                        disabled={employeeDetails?.terminate}
                      >
                        Terminate Employee
                      </Button>
                    }

                  </Grid>
                ) : (
                  <Grid xs={12} container className="mt40">
                    {roleManager("employeeLookup", "sections", "terminationDate") &&

                      <Button onClick={onClickRehireModal} className="LinkButton">
                        Re-Hire Employee
                      </Button>
                    }


                  </Grid>
                )}
              </>
            )}
          </Grid>

          <Grid xs={12} style={{ marginTop: "20px" }}>
            <Tabs activeKey={selectedTab} items={tabsItems} style={{ fontSize: '20px' }} className="custom-tabs" onChange={key => setSelectedTab(key)} />
          </Grid>

        </Grid>
      </Grid>

      <EmployeeDocumentDeleteModal open={isDeleteDocModalOpen} close={() => setIsDeleteDocModalOpen({ name: null, flag: false })} setFlag={setFlag} flag={flag} employeeDetails={employeeDetails} />
      <EditEmergencyContact EmergencyEditModal={emergencyModalData} />
      <StatusModal modalData={statusData} />
      <EmployeeIdModal ModalData={EmployeeIdModalData} />
      <SsnModal ssnModalData={SsnModalNumber} />
      <PhoneNumber modalData={phoneNumberModal} />
      <RehireModal RehireData={RehireModalData} />
      <AddressModal addressData={addressModalData} />
      <HireDateModal HireEditModal={HireModalData} />
      <TerminatedEditModal TerminatedModal={TerminateDate} />
      <DateOfBirth DateOfBirthData={DateOfBirthData} setFlag={setFlag} flag={flag} />

      <Snackbar></Snackbar>
    </PageLayout>
  );
};

export default EmployeeResult;
